import React from "react";
import BlogCard from "./blogCard";

function CategoryData(props) {

  return (
    <div className="category-data">
      {props.blogList && props.blogList.map(pd => <BlogCard blog={pd} />)}
    </div>
  );
}

export default CategoryData;
